import React, { FC } from 'react';

export const IconClose: FC<React.PropsWithChildren<{ className?: string }>> = ({ className = 'tw-w-4' }) => (
  // @ts-ignore slot attribute is required for market, but not part of the React svg type.
  <svg slot="icon" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path d="M10.6673 1.33398L1.33398 10.6673" stroke="currentColor" strokeWidth="2" />
    <path d="M1.33366 1.33398L10.667 10.6673" stroke="currentColor" strokeWidth="2" />
  </svg>
);
